import { useQuery } from '@apollo/client/react';

import GET_SWITCHES_FOR_ACCOUNT from '../gql/getSwitchesForAccount.gql';
import { DEFAULT_LOOKUP_SIZE, getOldest } from '@/lib/oldest';

/** The account's default switch: its oldest. `null` once loaded means the account has none. */
export const useDefaultSwitch = (accountId: string | null | undefined) => {
  const { data, loading, error, refetch } = useQuery(GET_SWITCHES_FOR_ACCOUNT, {
    variables: { id: accountId ?? undefined, first: DEFAULT_LOOKUP_SIZE },
    skip: !accountId,
  });

  const switches = data?.switchesForAccount?.edges.map(({ node }) => node) ?? [];

  return { defaultSwitch: getOldest(switches), loading, error, refetch };
};
